<template>
    <div class="input-div van-cell">
        <label style="width: 1.95rem">验证码：</label>
        <div>
            <div>
                <input type="text" v-model="verificationInfo.verificationCode" maxlength="4" placeholder="请输入验证码"
                       @focus="focusVerificationIconShow"
                       @blur="blurverificationIconShow"/>
                <van-icon class="clear-components-class" name="clear" size="0.42667rem" color="#c8c9cc"
                          v-show="verificationIconShow"
                          @click="clearContent"/>
            </div>
        </div>
        <img :src="verificationCodeImg" style="height: 0.77rem;border-radius: 44px;"
             @click="interactionVerificationCode"/>
    </div>
</template>

<script>
    /**
     * Description: 验证码输入框组件
     * Author: Wangyan
     * Date: 2019-03-02
     * Time: 16:22
     */
    import {Icon, Field} from 'vant'
    import Guid from '@assets/js/public/Guid'
    import {baseApiMap} from "@/api/base"

    export default {
        name: "VerificationCodeInput",
        components: {
            [Icon.name]: Icon,
            [Field.name]: Field,
        },
        data() {
            return {
                verificationInfo: {
                    verificationCode: '', // 验证码
                    verificationIsNoneStatus: false, // 是否输入验证码状态
                    verificationSuccessStatus: false, // 验证码是否输入正确状态
                    verificationCodeGuid: '' // 验证码guid
                },
                verificationCodeImg: '', // 验证码图片
                verificationIconShow: false, // 验证码清除按钮的显示与隐藏
            }
        },
        mounted() {
            this.interactionVerificationCode()
            this.monitorVerificationCode()
        },
        watch: {
            'verificationInfo.verificationCode'() {
                this.focusVerificationIconShow()
                this.monitorVerificationCode()
            }
        },
        methods: {
            /**
             * 获取验证码
             */
            async interactionVerificationCode() {
                try {
                    this.verificationInfo.verificationCode = ''
                    this.verificationInfo.verificationCodeGuid = new Guid().newGUID()
                    const res = await this.$httpUtils.postCommonUtils(`${baseApiMap.create}/${this.verificationInfo.verificationCodeGuid}`)
                    this.verificationCodeImg = "data:image/png;base64," + res.data.data
                } catch (error) {
                    console.log(error)
                }
            },

            /**
             * 输入框获取焦点显示图标显示
             */
            focusVerificationIconShow() {
                if (this.verificationInfo.verificationCode) {
                    this.verificationIconShow = true
                } else {
                    this.verificationIconShow = false
                }
            },

            /**
             * 输入框失去焦点显示图标显示
             */
            blurverificationIconShow() {
                setTimeout(() => {
                    this.verificationIconShow = false
                }, 1)
            },

            /**
             * 清除验证码
             */
            clearContent() {
                this.verificationInfo.verificationCode = ''
            },

            /**
             * 对验证码对是否有值，是否正确添加对应对状态
             */
            async monitorVerificationCode() {
                if (this.verificationInfo.verificationCode) {
                    this.verificationInfo.verificationIsNoneStatus = true
                    this.passValue()
                    if (this.verificationInfo.verificationCode.length === 4) {
                        try {
                            const res = await this.$httpUtils.postCommonUtils(`${baseApiMap.captcha}/${this.verificationInfo.verificationCodeGuid}/${this.verificationInfo.verificationCode}`)
                            if (res.data.succ) {
                                this.verificationInfo.verificationSuccessStatus = true
                                this.passValue()
                            } else {
                                this.verificationInfo.verificationSuccessStatus = false
                                this.passValue()
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.verificationInfo.verificationIsNoneStatus = false
                    this.passValue()
                }
            },
            /**
             * 验证码传值给父组件
             */
            passValue() {
                this.$emit('setVerificationCode', this.verificationInfo)
            }
        }
    }
</script>

<style lang="less" scoped>
    .input-div {
        width: 100%;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        box-sizing: border-box;
        line-height: 0.77rem;
        position: relative;
        background-color: #fff;
        color: #323233;
        font-size: 0.37333rem;
        overflow: hidden;

        div {
            color: #969799;
            overflow: hidden;
            text-align: right;
            position: relative;
            vertical-align: middle;
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            flex: 1;

            div {
                display: -webkit-box;
                display: -webkit-flex;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                align-items: center;

                input {
                    border: 0;
                    margin: 0;
                    padding: 0;
                    width: 100%;
                    resize: none;
                    display: block;
                    color: #323233;
                    box-sizing: border-box;
                    background-color: transparent;
                }
                input::-webkit-input-placeholder {
                    color: #999;
                }
                .clear-components-class {
                    margin: 0 0.3rem 0 0;
                }
            }
        }
    }
</style>
